/**
 * ACRES User Dashboard — tabbed shell
 * Wired into UserDashboard.tsx as the `acres` section.
 */
import React, { useState } from 'react';
import { AcresOverview } from './AcresOverview';
import { AcresBrowseTasks } from './AcresBrowseTasks';
import { AcresMySubmissions } from './AcresMySubmissions';
import { AcresLuckyDrawUser } from './AcresLuckyDrawUser';
import { AcresLeaderboardUser } from './AcresLeaderboardUser';

interface Props { user?: any; }
type TabId = 'overview' | 'tasks' | 'submissions' | 'draw' | 'leaderboard';

const TABS: Array<{ id: TabId; label: string; icon: string }> = [
  { id: 'overview',    label: 'Overview',     icon: '📊' },
  { id: 'tasks',       label: 'Browse Tasks', icon: '🎯' },
  { id: 'submissions', label: 'My Submissions', icon: '📋' },
  { id: 'draw',        label: 'Lucky Draw',   icon: '🎰' },
  { id: 'leaderboard', label: 'Leaderboard',  icon: '🏆' }
];

export const AcresUserDashboard: React.FC<Props> = ({ user }) => {
  const [tab, setTab] = useState<TabId>('overview');

  return (
    <div style={{ color: '#FFFFFF' }}>
      <div style={{ marginBottom: 16 }}>
        <h2 style={{ fontSize: 24, fontWeight: 700, color: '#F59E0B', margin: 0 }}>
          🎁 ACRES — Earn Real Aureus Shares
        </h2>
        <div style={{ fontSize: 13, color: '#9CA3AF', marginTop: 4 }}>
          Complete simple tasks to earn points. Convert points to fractional Aureus shares (1 point = 0.0001 share). Win monthly prizes.
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 20, borderBottom: '1px solid #1E1E1E', paddingBottom: 12 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: '8px 14px',
            borderRadius: 8,
            border: '1px solid ' + (tab === t.id ? '#F59E0B' : '#374151'),
            background: tab === t.id ? 'rgba(245,158,11,0.12)' : 'transparent',
            color: tab === t.id ? '#F59E0B' : '#E5E7EB',
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 600
          }}>
            <span style={{ marginRight: 6 }}>{t.icon}</span>{t.label}
          </button>
        ))}
      </div>

      {tab === 'overview' && <AcresOverview user={user} onJumpToTasks={() => setTab('tasks')} />}
      {tab === 'tasks' && <AcresBrowseTasks user={user} />}
      {tab === 'submissions' && <AcresMySubmissions user={user} />}
      {tab === 'draw' && <AcresLuckyDrawUser user={user} />}
      {tab === 'leaderboard' && <AcresLeaderboardUser user={user} />}
    </div>
  );
};

export default AcresUserDashboard;
